export const Medication = {
    medication: {
        version: ['e1'],
        timepoint: ['*'],
    },
};
